type SystemTarget = "werkAdmin" | "indexAdmin" | "werkServer" | "indexServer"

const DEFAULT_DOMAINS: Record<SystemTarget, string> = {
  werkAdmin: window.location.host.replace("app.", "werk-admin."),
  indexAdmin: window.location.host.replace("app.", "index-admin."),
  werkServer: window.location.host.replace("app.", "werk-server."),
  indexServer: window.location.host.replace("app.", "index-server."),
}

export const resolveWerkAdminOrigin = (): string => `https://${DEFAULT_DOMAINS["werkAdmin"]}`
export const resolveIndexAdminOrigin = (): string => `https://${DEFAULT_DOMAINS["indexAdmin"]}`
export const resolveWerkServerOrigin = (): string => `https://${DEFAULT_DOMAINS["werkServer"]}`
export const resolveIndexServerOrigin = (): string => `https://${DEFAULT_DOMAINS["indexServer"]}`
